import { render, staticRenderFns } from "./ApplicationUserPermissions.vue?vue&type=template&id=47004f42"
import script from "./ApplicationUserPermissions.vue?vue&type=script&lang=js"
export * from "./ApplicationUserPermissions.vue?vue&type=script&lang=js"
import style0 from "./ApplicationUserPermissions.vue?vue&type=style&index=0&id=47004f42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports